import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { ActivityEntry } from '../types';

const actionColors: Record<string, string> = {
  created: '#16a34a',
  updated: '#2563eb',
  retired: '#ea580c',
  csv_import: '#7c3aed',
};

export default function Activity() {
  const [entries, setEntries] = useState<ActivityEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get<ActivityEntry[]>('/activity')
      .then(setEntries)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>Loading...</div>;

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, margin: '0 0 16px', color: '#111' }}>Activity Log</h1>

      {entries.length === 0 ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#666', background: 'white', borderRadius: 12 }}>No activity recorded yet</div>
      ) : (
        <div style={{ background: 'white', borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
          {entries.map(entry => (
            <div key={entry.id} style={{ padding: '14px 20px', borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <span style={{ fontWeight: 600, fontSize: 14 }}>{entry.first_name} {entry.last_name}</span>
                  <span style={{
                    fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 4,
                    background: actionColors[entry.action] || '#6b7280', color: 'white',
                  }}>
                    {entry.action}
                  </span>
                  <span style={{ fontSize: 12, color: '#666' }}>{entry.entity_type}</span>
                </div>
                <div style={{ fontSize: 13, color: '#666' }}>
                  {entry.details?.description || 'No details'}
                </div>
              </div>
              <div style={{ fontSize: 12, color: '#999', whiteSpace: 'nowrap' }}>
                {new Date(entry.created_at).toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
